import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=27e697a4&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=ts&"
export * from "./Carousel.vue?vue&type=script&lang=ts&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=27e697a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e697a4",
  null
  
)

export default component.exports